import {
  FiCreditCard,
  FiFeather,
  FiLayout,
  FiTag,
  FiPieChart,
  FiSliders,
  FiThumbsUp,
  FiArchive,
  FiBell,
  FiBookOpen,
  FiBriefcase,
  FiCalendar,
  FiCloud,
  FiDollarSign,
  FiEdit3,
  FiLifeBuoy,
  FiTrendingUp,
  FiActivity,
  FiAward,
  FiCheckCircle,
  FiClipboard,
  FiClock,
  FiCoffee,
  FiDownload,
  FiEye,
  FiFileText,
  FiFolder,
  FiHeart,
  FiLock,
  FiMail,
  FiMapPin,
  FiMessageCircle,
  FiMonitor,
  FiNavigation,
  FiPhone,
  FiPhoneCall,
  FiSearch,
  FiShield,
  FiSmartphone,
  FiUser,
  FiUserCheck,
  FiUsers,
} from "react-icons/fi";
import { TbRubberStamp } from "react-icons/tb";

// Contents of the "En savoir plus" sections displayed below the order forms

export const legalFormsGuide = {
  title: "Bien choisir sa forme juridique",
  intro:
    "La forme juridique détermine qui peut créer la structure, le capital à apporter et l'étendue de votre responsabilité.",
  items: [
    {
      icon: FiUser,
      title: "ETS (Établissement)",
      text: "Vous exercez seul, sans capital minimum. Votre patrimoine personnel n'est pas séparé de celui de l'entreprise : vous répondez des dettes sur vos biens.",
    },
    {
      icon: FiUserCheck,
      title: "SARLU",
      text: "Vous êtes l'unique associé et votre responsabilité est limitée à votre apport. Capital à partir de 100 000 FCFA.",
    },
    {
      icon: FiUsers,
      title: "SARL",
      text: "Vous vous associez à plusieurs. Chaque associé n'est responsable qu'à hauteur de son apport. Capital à partir de 100 000 FCFA.",
    },
    {
      icon: FiHeart,
      title: "Association",
      text: "Au moins deux personnes réunies autour d'un projet sans but lucratif : culturel, social, sportif ou solidaire.",
    },
  ],
  note: "Délai de création : une semaine en moyenne, une fois votre dossier complet et payé.",
};

export const documentsGuide = {
  title: "Bien préparer vos documents",
  intro:
    "Des documents complets et lisibles permettent à nos conseillers de traiter votre dossier sans aller-retour.",
  items: [
    {
      icon: FiFileText,
      title: "Formats acceptés",
      text: "PDF, JPG ou PNG, jusqu'à 100 Mo par fichier. Un fichier par document demandé.",
    },
    {
      icon: FiEye,
      title: "Des pièces lisibles",
      text: "Chaque document doit être lisible en entier, sans reflet ni partie coupée, et en cours de validité.",
    },
    {
      icon: FiSmartphone,
      title: "Pas de scanner ?",
      text: "Une photo nette prise avec votre téléphone, dans un endroit bien éclairé, convient parfaitement.",
    },
    {
      icon: FiMessageCircle,
      title: "Une pièce vous manque ?",
      text: "Poursuivez votre commande et transmettez les documents manquants plus tard à nos conseillers via WhatsApp.",
    },
  ],
};

export const oapiGuide = {
  title: "La protection de votre nom commercial à l'OAPI",
  intro:
    "L'OAPI (Organisation Africaine de la Propriété Intellectuelle) protège votre nom commercial dans ses 17 États membres. Nous prenons en charge toute la démarche.",
  items: [
    {
      icon: FiFolder,
      title: "Montage du dossier",
      text: "Nous constituons votre dossier d'enregistrement dans le respect des exigences légales et administratives de l'OAPI.",
    },
    {
      icon: FiSearch,
      title: "Recherche d'antériorité",
      text: "Environ 2 semaines pour vérifier que votre nom est disponible et éviter tout conflit avec une marque existante.",
    },
    {
      icon: FiShield,
      title: "Dépôt et protection",
      text: "Nous déposons votre demande auprès de l'OAPI. Votre nom est protégé dès le dépôt.",
    },
    {
      icon: FiAward,
      title: "Documents officiels",
      text: "L'OAPI délivre les documents officiels de protection dans un délai de 3 à 6 mois.",
    },
  ],
};

export const domiciliationGuide = {
  title: "Ce que comprend la domiciliation",
  intro:
    "Une adresse professionnelle et des services pour gérer votre entreprise sereinement, sans bureau à vous.",
  items: [
    {
      icon: FiMapPin,
      title: "Adresse administrative et fiscale",
      text: "Votre siège social à une adresse professionnelle, avec une attestation de domiciliation.",
    },
    {
      icon: FiMail,
      title: "Gestion du courrier",
      text: "Nous réceptionnons et trions votre courrier, puis nous le numérisons et vous le transmettons par e-mail ou le réexpédions.",
    },
    {
      icon: FiPhoneCall,
      title: "Accueil téléphonique",
      text: "Un accueil téléphonique personnalisé pour gagner en efficacité et en professionnalisme.",
    },
    {
      icon: FiUsers,
      title: "Salle de réunion",
      text: "Recevez vos clients et partenaires dans une salle équipée, jusqu'à 2 h par jour dans la limite de 16 h par mois.",
    },
    {
      icon: FiCoffee,
      title: "Espace de coworking",
      text: "Travaillez dans un espace partagé, jusqu'à 4 h par jour dans la limite de 32 h par mois.",
    },
    {
      icon: FiNavigation,
      title: "Localisation fiscale",
      text: "Une localisation fiscale adaptée à vos besoins administratifs et comptables, en toute conformité.",
    },
  ],
  note: "La salle de réunion et l'espace de coworking sont accessibles sur réservation, selon les disponibilités.",
};

export const paymentGuide = {
  title: "Comment se déroule le paiement ?",
  intro:
    "Le paiement se fait par MTN Mobile Money ou Orange Money, en quelques secondes.",
  items: [
    {
      icon: FiSmartphone,
      title: "1. Une demande sur votre téléphone",
      text: "Après avoir cliqué sur « Procéder au paiement », une demande de paiement arrive sur le numéro indiqué.",
    },
    {
      icon: FiLock,
      title: "2. Vous validez",
      text: "Vous confirmez le paiement avec votre code secret Mobile Money, directement sur votre téléphone.",
    },
    {
      icon: FiCheckCircle,
      title: "3. Commande confirmée",
      text: "Votre commande est enregistrée dès réception du paiement et vous recevez un e-mail de confirmation.",
    },
    {
      icon: FiShield,
      title: "Votre sécurité",
      text: "Platform98 ne vous demandera jamais votre code secret, ni par SMS, ni par appel, ni sur WhatsApp.",
    },
  ],
};

export const nextStepsGuide = {
  eyebrow: "La suite",
  title: "Et maintenant ?",
  items: [
    {
      icon: FiClipboard,
      title: "Vérification du dossier",
      text: "Un conseiller Platform98 vérifie votre dossier et vos documents.",
    },
    {
      icon: FiPhone,
      title: "Nous restons en contact",
      text: "Si un document manque ou doit être corrigé, nous vous contactons.",
    },
    {
      icon: FiActivity,
      title: "Suivi en ligne",
      text: "Suivez l'avancement depuis votre tableau de bord, rubrique « Mes démarches ».",
    },
    {
      icon: FiDownload,
      title: "Vos documents officiels",
      text: "Ils sont disponibles dans votre espace dès leur délivrance.",
    },
  ],
};

export const formalitiesGuide = {
  title: "Vos formalités, sans vous déplacer",
  items: [
    {
      icon: FiMonitor,
      title: "100 % en ligne",
      text: "Répondez à quelques questions et envoyez vos documents depuis votre téléphone ou votre ordinateur.",
    },
    {
      icon: FiClock,
      title: "Des délais annoncés",
      text: "Le délai moyen est indiqué pour chaque formalité lorsqu'il est connu.",
    },
    {
      icon: FiUserCheck,
      title: "Un conseiller dédié",
      text: "Un conseiller prend en charge votre démarche et vous tient informé à chaque étape.",
    },
  ],
};

export const adminGuide = {
  title: "L'administration de votre entreprise",
  intro:
    "Simplifiez la gestion administrative de votre entreprise grâce à un suivi rigoureux et une conformité légale optimale.",
  items: [
    {
      icon: FiCalendar,
      title: "Télédéclaration mensuelle",
      text: "Nous soumettons vos déclarations fiscales en ligne dans le respect des échéances, pour une gestion efficace et conforme.",
    },
    {
      icon: FiFileText,
      title: "Déclaration statistique et fiscale",
      text: "La DSF est une obligation annuelle. Nous collectons, vérifions et soumettons vos données fiscales et statistiques.",
    },
    {
      icon: FiUsers,
      title: "Cotisations sociales",
      text: "Nous gérons vos cotisations sociales et veillons à la transmission rapide et sécurisée de vos données.",
    },
  ],
};

export const grhGuide = {
  title: "La gestion de vos ressources humaines",
  intro:
    "Une relation employeur-employé claire et conforme à la législation, sans charge administrative pour vous.",
  items: [
    {
      icon: FiEdit3,
      title: "Gestion des contrats",
      text: "Nous rédigeons et mettons à jour vos contrats de travail, accords de confidentialité et accords de mission, conformément aux lois en vigueur.",
    },
    {
      icon: FiDollarSign,
      title: "Bulletins de paie",
      text: "Un traitement précis et ponctuel des salaires, dans le respect de vos obligations fiscales et sociales.",
    },
    {
      icon: FiLifeBuoy,
      title: "Rupture de contrat",
      text: "Nous vous accompagnons lors d'un licenciement, d'une démission ou d'une fin de CDD, dans le respect des procédures et des droits des employés.",
    },
  ],
};

export const juridiqueGuide = {
  title: "Le suivi juridique de votre entreprise",
  intro:
    "Protégez vos intérêts et sécurisez vos activités grâce à un accompagnement juridique adapté à vos besoins.",
  items: [
    {
      icon: FiShield,
      title: "Contentieux professionnels",
      text: "Nous vous accompagnons dans vos litiges avec des solutions juridiques adaptées pour protéger vos droits et limiter les risques.",
    },
    {
      icon: FiBriefcase,
      title: "Contrats d'affaires",
      text: "Nous rédigeons, révisons et sécurisons vos contrats commerciaux pour des relations d'affaires conformes et solides.",
    },
    {
      icon: FiArchive,
      title: "Secrétariat juridique",
      text: "Assemblées générales, procès-verbaux, dépôt des documents : nous gérons vos obligations légales.",
    },
  ],
};

export const salesGuide = {
  title: "La gestion de votre relation client",
  intro:
    "Un suivi structuré de vos clients et de vos relances pour développer votre activité commerciale.",
  items: [
    {
      icon: FiUserCheck,
      title: "Suivi client",
      text: "Un suivi personnalisé de vos clients pour renforcer leur satisfaction et leur fidélité.",
    },
    {
      icon: FiBell,
      title: "Relances clients",
      text: "Des relances efficaces et professionnelles pour améliorer vos conversions et limiter les impayés.",
    },
    {
      icon: FiBookOpen,
      title: "Comptes rendus de réunion",
      text: "Nous rédigeons vos comptes rendus pour suivre les décisions prises et rester organisé.",
    },
    {
      icon: FiTrendingUp,
      title: "Fichier clients",
      text: "Vos informations clients centralisées et organisées pour une relation commerciale fluide.",
    },
  ],
};

export const managementGuide = {
  title: "La gestion de votre activité",
  intro:
    "Des outils modernes pour piloter votre entreprise au quotidien, où que vous soyez.",
  items: [
    {
      icon: FiFileText,
      title: "Devis",
      text: "Créez des devis professionnels et personnalisés en quelques clics pour vos clients et partenaires.",
    },
    {
      icon: FiDollarSign,
      title: "Factures",
      text: "Générez des factures conformes et détaillées pour suivre vos transactions.",
    },
    {
      icon: FiClipboard,
      title: "Secrétariat personnalisé",
      text: "Un secrétariat dédié vous assiste dans vos tâches administratives au quotidien.",
    },
    {
      icon: FiCloud,
      title: "ERP 100 % en ligne",
      text: "Pilotez votre entreprise depuis une solution ERP centralisée, accessible en ligne.",
    },
  ],
};

export const shareCapitalGuide = {
  title: "Qu'est-ce que le capital social ?",
  intro:
    "Le capital social correspond aux apports des associés au moment de la création. Il constitue les premières ressources de l'entreprise et une garantie pour ses partenaires.",
  items: [
    {
      icon: FiPieChart,
      title: "Des apports répartis",
      text: "Dans une SARL, le capital est divisé en parts entre les associés, en fonction de ce que chacun apporte.",
    },
    {
      icon: FiSliders,
      title: "Quel montant choisir ?",
      text: "À partir de 100 000 FCFA. Adaptez le montant à votre projet : un capital plus élevé rassure davantage banques et partenaires.",
    },
    {
      icon: FiThumbsUp,
      title: "Rien à nous verser",
      text: "Indiquez simplement le montant prévu. Pour la création de votre entreprise, vous n'avez ni à nous verser ce capital, ni à nous en fournir un justificatif.",
    },
  ],
};

export const businessNameGuide = {
  title: "Bien choisir le nom de votre entreprise",
  intro:
    "Le nom figure dans les statuts et sur tous les documents officiels de votre entreprise. Prenez le temps de bien le choisir.",
  items: [
    {
      icon: FiTag,
      title: "Vous avez déjà un nom",
      text: "Indiquez-le simplement : nous l'utilisons pour préparer les statuts et le dossier de création.",
    },
    {
      icon: FiFeather,
      title: "Nous le trouvons avec vous",
      text: "Nous vous proposons un nom adapté à votre activité, facile à retenir et disponible.",
    },
    {
      icon: FiLayout,
      title: "Protégez-le à l'OAPI",
      text: "En option, votre nom commercial peut être protégé dans les 17 États membres de l'OAPI.",
    },
    {
      icon: FiCreditCard,
      title: "Logo et supports",
      text: "Logo, cartes de visite et plaquettes vous sont proposés à l'étape des services.",
    },
  ],
};

export const visualIdentityGuide = {
  title: "Votre identité visuelle",
  intro:
    "Donnez une image professionnelle à votre entreprise dès son lancement, avec des supports conçus par nos graphistes.",
  items: [
    {
      icon: FiFeather,
      title: "Un logo professionnel",
      text: "Une identité visuelle forte et moderne, qui reflète l'essence de votre entreprise.",
    },
    {
      icon: FiCreditCard,
      title: "Des cartes de visite",
      text: "Un design soigné pour laisser une impression durable à vos partenaires et clients.",
    },
    {
      icon: FiLayout,
      title: "Des plaquettes",
      text: "Un support clair pour présenter votre activité et vos offres à vos prospects.",
    },
    {
      icon: TbRubberStamp,
      title: "Un cachet",
      text: "Un cachet à vos nom et coordonnées, pour authentifier vos documents.",
    },
  ],
};
